import { api } from '@/lib/api';

export const postSchoolApplication = (body: any): Promise<any> =>
  api.post('/public/school-onboarding', body);
